<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <div class="tile-categorie-frame">
          <div class="tile-categorie px-3">
            <div class="body">
              <div class="row">
                <div class="mut-header-bg ml-0">
                  <div
                    class="mut-header pointer"
                    style="height: 50px"
                    :class="{ 'mut-selected': activeHeadline === 2 }"
                    @click="setAllAssigned"
                  >
                    <div class="mut-headers">
                      <span class="primary-headline-text">{{
                        lead
                          ? $t("global.assignedtome")
                          : "Dieser Person zugewiesen"
                      }}</span>
                    </div>
                  </div>
                  <div
                    v-if="lead"
                    class="mut-header pointer"
                    style="height: 50px"
                    :class="{ 'mut-selected': activeHeadline === 3 }"
                    @click="setAssignedToOthers"
                  >
                    <div class="mut-headers">
                      <span class="primary-headline-text">{{
                        $t("global.assignedtoothers")
                      }}</span>
                    </div>
                  </div>
                  <div
                    v-if="lead"
                    class="mut-header pointer"
                    style="height: 50px"
                    :class="{ 'mut-selected': activeHeadline === 4 }"
                    @click="setPersonal"
                  >
                    <div class="mut-headers">
                      <span class="primary-headline-text">{{
                        $t("global.personal")
                      }}</span>
                    </div>
                  </div>
                  <div
                    v-if="lead"
                    class="mut-header pointer"
                    style="height: 50px"
                    :class="{ 'mut-selected': activeHeadline === 1 }"
                    @click="setAllPending"
                  >
                    <div class="mut-headers">
                      <span class="primary-headline-text">{{
                        $t("global.notassigned")
                      }}</span>
                      <div class="red-dot" v-if="pendingCount">
                        {{ pendingCount }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row d-flex justify-content-between">
                  <div class="ml-4">
                    <button class="btn btn-success" @click="neueAktivitaet">
                      <font-awesome-icon
                        icon="fa-duotone fa-comments-alt"
                        class="mr-2"
                      />
                      <span>{{ $t("global.new") }}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 block belegliste br-t-l-0">
                  <b-table
                    ref="todoTable"
                    class="text-center"
                    thead-class="sticky-blue-bg"
                    tbody-tr-class="item p-1"
                    responsive
                    hover
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-compare="sortDates"
                    :busy="pendenzenIsBusy"
                    show-empty
                    :items="aktivitaeten"
                    :fields="fields"
                    @row-dblclicked="aktivitaetOeffnen"
                  >
                    <template v-slot:cell(datum)="row">
                      <div class="datum" :class="datumColor(row.item)">
                        {{ row.item.geplantdatum }}
                      </div>
                    </template>
                    <template v-slot:cell(status)="row">
                      <div class="status" :class="statusBackground(row.item)">
                        {{
                          row.item?.status?.bezeichnung
                            ? row.item.status.bezeichnung
                            : "-"
                        }}
                      </div>
                    </template>
                    <template #cell(details)="row">
                      <b-button
                        @click="row.toggleDetails"
                        class="m-0"
                        variant="outline-primary"
                        size="sm"
                      >
                        <font-awesome-icon
                          :icon="
                            row.detailsShowing
                              ? 'fa-chevron-up'
                              : 'fa-chevron-down'
                          "
                        />
                      </b-button>
                    </template>
                    <template #row-details="row">
                      <div class="mb-2">
                        {{
                          row.item.beschreibung || $t("global.nodescription")
                        }}
                      </div>
                    </template>
                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </template>

                    <template #empty>
                      <div
                        v-if="pendenzenLadeFehler"
                        class="text-center text-danger my-2"
                      >
                        <strong>{{ $t("global.errorwhileloading") }}</strong>
                      </div>
                      <div
                        v-if="!pendenzenLadeFehler"
                        class="text-center text-primary my-2"
                      >
                        <strong>{{
                          $t("global.therearenopendingtodos")
                        }}</strong>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <aktivitaet-modal
      :isKontaktbasiert="standardContactbased || false"
      :kontakt="geschaeftspartner"
      :angemeldeterMitarbeiter="angemeldeterMitarbeiter"
      @aktivitaetCreated="aktivitaetErstellt"
      @aktivitaetChanged="aktivitaetGeaendert"
      @aktivitaetDeleted="aktivitaetDeleted"
      :pendenzenIsBusy="pendenzenIsBusy"
    />
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import AktivitaetService from "@/service/AktivitaetService";
import store from "@/store";

import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
// import AktivitaetModal from "@/components/crm/AktivitaetModal";
import AktivitaetModal from "@/newviva/components/Modale/AktivitaetModalNewViva";
import page from "@/mixins/Page";

export default {
  name: "PendenzenReiter",
  components: { BSpinner, AktivitaetModal },
  store,
  mixins: [page],
  props: {
    person: {
      type: String,
      required: false,
    },
    lead: {
      type: String,
      required: false,
    },
    geschaeftspartner: {
      type: Object,
      required: false,
    },
    firma: {
      type: Object,
      required: false,
    },
    standardContactbased: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      pendenzenIsBusy: false,
      pendenzenLadeFehler: false,

      aktivitaeten: [],
      sortBy: "geplantdatum",
      sortDesc: false,
      activeHeadline: 2,
      pendingCount: null,
    };
  },
  created() {
    if (this.angemeldeterMitarbeiter) {
      this.getAktivitaeten();
    }

    this.countPending();
  },
  mounted() {
    this.$bus.$on("prozess-sidebar-reload", () => {
      this.countPending();
    });
  },
  watch: {
    angemeldeterMitarbeiter: function (val) {
      if (val) {
        this.getAktivitaeten();
      }
    },
  },
  computed: {
    fields() {
      return [
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.task"),
        },
        {
          key: "typ.bezeichnung",
          sortable: true,
          label: this.$t("global.type"),
        },
        {
          key: "datum",
          sortable: true,
          label: this.$t("global.dashboard_planneddate"),
          sortByFormatted: true,
          formatter: (value, key, item) => item.geplantdatum,
        },
        {
          key: "person.personName",
          sortable: true,
          label: this.$t("global.RESponsible"),
          sortByFormatted: true,
          formatter: (value, key, item) =>
            item.verantwortlicher.map((person) => person.personName).join(", "),
        },
        {
          key: "status",
          sortable: true,
          label: this.$t("global.status"),
        },
        {
          key: "details",
          sortable: false,
          label: "",
        },
      ];
    },
  },
  methods: {
    getAktivitaeten() {
      this.pendenzenIsBusy = true;
      let params = {};

      if (this.person) params.personId = this.person;
      if (this.lead) params.leadId = this.lead;

      if (this.activeHeadline === 1) {
        params.pendenzenmodus = "allpending";
      } else if (this.activeHeadline === 2) {
        params.pendenzenmodus = "allassigned";
      } else if (this.activeHeadline === 3) {
        params.pendenzenmodus = "assignedtoothers";
      } else if (this.activeHeadline === 4) {
        params.pendenzenmodus = "personal";
      }

      AppApi.get("aktivitaet/", { params })
        .then((response) => {
          this.aktivitaeten = response.data;
          params.pendenzenmodus === "allpending"
            ? (this.pendingCount = response.data.length)
            : "";
          this.pendenzenLadeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.pendenzenLadeFehler = true;
        })
        .finally(() => {
          this.pendenzenIsBusy = false;
        });
    },

    neueAktivitaet() {
      if (
        !this.geschaeftspartner.personName &&
        this.geschaeftspartner.personenangaben
      ) {
        this.geschaeftspartner.personName =
          this.geschaeftspartner.personenangaben.name +
          " " +
          this.geschaeftspartner.personenangaben.vorname;
      }

      let json = {
        person: this.person,
        firma: this.firma,
        lead: this.lead,
        neu: true,
      };

      this.$bus.$emit("aktivitaet-modal-show", json);
    },

    aktivitaetOeffnen(aktivitaet) {
      this.$bus.$emit("aktivitaet-modal-show", aktivitaet);
    },

    aktivitaetDeleted(aktivitaet) {
      AktivitaetService.deleteAktivitaet([aktivitaet.id], this);
    },

    aktivitaetErstellt(aktivitaet) {
      let json = aktivitaet;
      json.lead = this.lead;

      AktivitaetService.createAktivitaet(json, this);
    },

    aktivitaetGeaendert(aktivitaet) {
      let json = aktivitaet;
      json.lead = this.lead;

      AktivitaetService.updateAktivitaet(json, this);
    },

    setAllPending() {
      this.activeHeadline = 1;
      this.getAktivitaeten();
    },
    setAllAssigned() {
      this.activeHeadline = 2;
      this.getAktivitaeten();
    },
    setAssignedToOthers() {
      this.activeHeadline = 3;
      this.getAktivitaeten();
    },
    setPersonal() {
      this.activeHeadline = 4;
      this.getAktivitaeten();
    },
    statusBackground(item) {
      let status = item.status;

      if (status) {
        //Geplant:
        if (status.id == "17FD0A1A4A1") {
          return "statusWarn";
        }
        //Durchgeführt:
        else if (status.id == "17FD0A1BEE5") {
          return "statusSuccess";
        }
        //Abgesagt:
        else if (status.id == "17FD0A1E99E") {
          return "statusDanger";
        }
        // in Arbeit
        else {
          return "statusPrimary";
        }
      } else return "";
    },
    datumColor(datum) {
      //wenn datum oder datum.geplantdatum null ist, nichts returnen
      if (!datum || !datum.geplantdatum) return "";
      // Umwandeln des heutigen Datums in das numerische Format
      var today = ((date) => {
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return (
          parseInt(year, 10) * 10000 +
          parseInt(month, 10) * 100 +
          parseInt(day, 10)
        );
      })(new Date());

      // Umwandeln von geplantdatum in das numerische Format für den Vergleich
      var datumNum = ((datumStr) => {
        const [day, month, year] = datumStr.split(".");
        return (
          parseInt(year, 10) * 10000 +
          parseInt(month, 10) * 100 +
          parseInt(day, 10)
        );
      })(datum.geplantdatum);

      if (datumNum < today) {
        return "pastDate";
      }
    },

    countPending() {
      this.pendenzenIsBusy = true;

      let params = {};

      if (this.person) params.personId = this.person;
      if (this.lead) params.leadId = this.lead;

      params.pendenzenmodus = "allpending";

      AppApi.get("aktivitaet/", { params })
        .then((response) => {
          this.pendingCount = response.data.length;
          this.pendenzenLadeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.pendenzenLadeFehler = true;
        })
        .finally(() => {
          this.pendenzenIsBusy = false;
        });
    },
  },
};
</script>
